/** Runtime configuration for the hosted checkout, read from Vite env at build time. */
export type NetworkMode = 'mainnet' | 'testnet';

const env = import.meta.env as Record<string, string | undefined>;

export const config = {
  apiBase: (env.VITE_CV_API_BASE ?? 'https://api.coinvello.com/v1').replace(/\/$/, ''),
  walletConnectProjectId: env.VITE_CV_WALLETCONNECT_PROJECT_ID ?? '',
  network: (env.VITE_CV_NETWORK === 'testnet' ? 'testnet' : 'mainnet') as NetworkMode,
  allowedEmbedOrigins: (env.VITE_CV_ALLOWED_EMBED_ORIGINS ?? '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean),
  manifestPubkey: env.VITE_CV_MANIFEST_PUBKEY ?? '',
  pollIntervalMs: 5000,
  appName: 'CoinVello Checkout',
  appUrl: 'https://pay.coinvello.com',
  appLogo: 'https://pay.coinvello.com/icon.svg',
};
